import { useQuery } from 'react-query';
import { useFirebase } from 'components/Firebase/index.js';
import { useOrgId } from 'hooks/index.js';

export const orgCreditsBalanceQueryKey = (orgId) => ['creditsBalance', orgId];

const useOrganizationCreditsBalance = () => {
  const firebase = useFirebase();
  const orgId = useOrgId();

  return useQuery({
    queryKey: orgCreditsBalanceQueryKey(orgId),
    queryFn: async () => {
      const agent = await firebase.getAgent();

      const response = await agent.get(`/o/${orgId}/creditsBalance`);
      return response?.body;
    },
  });
};

export default useOrganizationCreditsBalance;
